export default "__VITE_ASSET__CLDLPNJZ__"